export interface SagaData {
  popupSeen: string;
  ppdVideoLoaded: string;
  ppdCreated: string;
  lactateVideoLoaded: string;
  lactateCreated: string;
  useCasesSeen: Record<number, string>;
  completed: string;
}

export interface ISaga {
  current_step: SagaStepEnum;
  guid: string;
  saga_data: Partial<SagaData>;
  status: string;
}

export enum SagaStepEnum {
  started = 1,
  dataSelection = 2,
  exploring = 3,
  completed = 4,
  skipped = 5,
}
